import React from "react"
import { Link } from "gatsby"
import FacebookFooterIcon from "./icons/facebookFooterIcon"
import InstagramFooterIcon from "./icons/instagramFooterIcon"
import "./footer.css"

export default function Footer({ menuLinks, siteTitle }) {
  return (
    <footer
      className="page-footer font-small pt-1"
      style={{ backgroundColor: "#DCDCDC", borderTop: "2px solid" }}
    >
      <div className="container-fluid text-center text-md-left">
        <div className="row">
          <div className="col-md-4 mb-md-0 mb-3">
            <h5 className="font-weight-bold mt-1 mb-2 text-center">LINKS</h5>
            <ul className="list-unstyled text-center">
              {menuLinks.map(link => (
                <li key={link.name}>
                  <Link className="footer-link" to={link.link}>
                    {link.name}
                  </Link>
                </li>
              ))}
              <li key="Disclaimer">
                <Link className="footer-link" to="/disclaimer">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-md-4 mb-md-0 mb-3">
            <h5 className="font-weight-bold mt-1 mb-2 text-center">
              SOCIAL MEDIA
            </h5>
            <ul className="list-unstyled" style={{ textAlign: "center" }}>
              <li key="Facebook-Footer-Icon">
                <a
                  href="https://www.facebook.com/MarsdenParkRFS/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookFooterIcon />
                </a>
              </li>
              <li key="Instagram-Footer-Icon">
                <a
                  href="https://www.instagram.com/marsden_park_rfb/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <InstagramFooterIcon />
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-4 mb-md-0 mb-3 pt-3">
            <div style={{ textAlign: "center", fontSize: "15px" }}>
              Built, designed and maintained by{" "}
              <a
                className="footer-link"
                href="https://www.linkedin.com/in/matthew-dylan-freeman/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Matthew Freeman
              </a>
            </div>
            <div className="footer-copyright text-center">
              © {new Date().getFullYear()} {siteTitle}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
